import baseApi from 'services/api/base';
import getProductKey from 'helper/requests/getProductKey';
import { WBSequentialMapsOptions } from 'types/Meteorology/Agro/WaterBalanceSequential/Maps/getOptions';
import { GetWBSequentialMapDataParams, WBSequentialMapData } from 'types/Meteorology/Agro/WaterBalanceSequential/Maps/getMapData';
import { transformGetOptionsResponse, transformMapDataResponse } from 'helper/Meteorology/Agro/WaterBalanceSequential/Maps';

export const waterBalanceSequentialMapsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getWBSequentialMapsOptions: build.query<WBSequentialMapsOptions, void>({
      query: () => {
        const productKey = getProductKey('agro');
        return {
          url: `produtos/agro/balanco-hidrico/sequencial/mapas/painel-options/?product_key=${productKey}`,
          method: 'GET',
        };
      },
      transformResponse: transformGetOptionsResponse,
    }),
    getWBSequentialMapData: build.query<WBSequentialMapData, GetWBSequentialMapDataParams>({
      query: ({ variable, startDate, endDate }) => {
        const productKey = getProductKey('agro');
        return {
          url: `produtos/agro/balanco-hidrico/sequencial/mapas/array-dados/?product_key=${productKey}`,
          method: 'POST',
          body: {
            var: variable,
            data_inicial: startDate,
            data_final: endDate,
          },
        };
      },
      transformResponse: transformMapDataResponse,
    }),
  }),
});

export const {
  useGetWBSequentialMapsOptionsQuery,
  useGetWBSequentialMapDataQuery,
  useLazyGetWBSequentialMapDataQuery,
} = waterBalanceSequentialMapsApi;
